const createDefaultClient = () => ({
    id: null,
    seller_id: null,
    user_id: null,
    guest_id: null,
    name: null,
    options: {
        latest_address_id: null,
    },
    addresses: [],
    phones: [],
    deleted_at: null,
});

const cloneCollection = (collection) => Array.isArray(collection)
    ? collection.map((item) => (item ? {...item} : item))
    : [];

const normalizeOptions = (options = {}) => ({
    latest_address_id: null,
    ...options,
});

export default {
    state: () => ({
        client: createDefaultClient(),
    }),
    mutations: {
        load_client(state, data) {
            state.client = data
                ? {
                    id: data.id ?? null,
                    seller_id: data.seller_id ?? null,
                    user_id: data.user_id ?? null,
                    guest_id: data.guest_id ?? null,
                    name: data.name ?? null,
                    options: normalizeOptions(data.options),
                    addresses: cloneCollection(data.addresses),
                    phones: cloneCollection(data.phones),
                    deleted_at: data.deleted_at ?? null,
                }
                : createDefaultClient();
            if (!state.client.options.latest_address_id && state.client.addresses.length) {
                state.client.options.latest_address_id = state.client.addresses[0].id;
            }
        },
        save_address(state, address) {
            if (!state.client) {
                return;
            }
            state.client.options = normalizeOptions(state.client.options);
            state.client.options.latest_address_id = address?.id ?? null;
            const addressIndex = state.client.addresses.findIndex((item) => item.id === address.id);
            if (addressIndex !== -1) {
                state.client.addresses.splice(addressIndex, 1, address);
            } else {
                state.client.addresses.push(address);
            }
        },
        add_address(state, address) {
            if (!state.client) {
                return;
            }
            state.client.options = normalizeOptions(state.client.options);
            state.client.options.latest_address_id = address?.id ?? null;
            if (state.client.addresses.some((item) => item.id === address.id)) {
                return;
            }
            state.client.addresses.push(address);
        },
        add_user_client_phone(state, phone) {
            if (!state.client) {
                return;
            }
            if (state.client.phones.some((item) => item.id === phone.id)) {
                return;
            }
            state.client.phones.push(phone);
        },
        delete_user_client_phone(state, phoneId) {
            if (!state.client) {
                return;
            }
            const index = state.client.phones.findIndex((phone) => phone.id === phoneId);
            if (index !== -1) {
                state.client.phones.splice(index, 1);
            }
        },
    },
    actions: {
        load_client({commit}, data) {
            commit('load_client', data);
        },
        save_address({commit}, address) {
            commit('save_address', address);
        },
        add_address({commit}, address) {
            commit('add_address', address);
        },
        add_user_client_phone({commit}, phone) {
            commit('add_user_client_phone', phone);
        },
        delete_user_client_phone({commit}, phoneId) {
            commit('delete_user_client_phone', phoneId);
        },
    },
    getters: {
        client(state) {
            return state.client;
        },
    }
}
